import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1, 3],
      rowsSize: [1, 4, 4],
      rowSpan: {
        "1:1": 2,
      },
      colSpan: {
        "0:0": 2,
      },
      gap: "17px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                // alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data: "Data Acquisition and Generation: Test Bench",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-end",
              },
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/5-thumb.png`,
                  styles: {
                    maxHeight: "225px",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/5-main.png`,
                  viewType: "contain",
                  styles: {
                    maxWidth: "663px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data:
                    "Once the transfer paths for a given vehicle are known, these paths can also be combined with data recorded from a test bench. Utilizing this technique engines can be evaluated via test drives, while still on the test bench, allowing for faster development cycles.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
